/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';
import pluralize from 'pluralize';

import { VIRTUAL_DEVICE, REAL_DEVICE, TESTING_TYPES } from '../../../constants';
import { Subscription } from '../../../records/Subscription';

interface ProductConcurrencyBoxProps {
  concurrency: number
}
const LiveConcurrency: React.FC<ProductConcurrencyBoxProps> = ({ concurrency }) => (
  <>
    <strong>{`Tests: ${concurrency}`}</strong>
    {` parallel ${pluralize('test', concurrency)}`}
  </>
);
const VDCConcurrency: React.FC<ProductConcurrencyBoxProps> = ({ concurrency }) => (
  <>
    <strong>{`Virtual Devices: ${concurrency}`}</strong>
    {` parallel ${pluralize('test', concurrency)}`}
  </>
);
const RDCConcurrency: React.FC<ProductConcurrencyBoxProps> = ({ concurrency }) => (
  <>
    <strong>{`Real Devices: ${concurrency}`}</strong>
    {` parallel ${pluralize('test', concurrency)}`}
  </>
);

interface ConcurrencyBoxProps {
  concurrency: number
  subscription: Subscription
}
/* eslint-disable no-else-return */
const ConcurrencyBox: React.FC<ConcurrencyBoxProps> = ({ subscription, concurrency }) => {
  if (subscription.plan.testing_type === TESTING_TYPES.LIVE) {
    return <LiveConcurrency concurrency={concurrency} />;
  } else {
    if (subscription.plan.device_type === VIRTUAL_DEVICE) {
      return <VDCConcurrency concurrency={concurrency} />;
    }
    if (subscription.plan.device_type === REAL_DEVICE) {
      return <RDCConcurrency concurrency={concurrency} />;
    }
  }
  return <span>{subscription.plan.device_type}</span>;
};

export { ConcurrencyBox };
